import DeleteConfirmPopover from './DeleteConfirmPopover';

export default DeleteConfirmPopover;
